import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { removeFavReport } from './favReportSlice';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const DeleteButton = ({ frName }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const orgId = useSelector((state) => state.users.user.usrOrgId);
  const usrId = useSelector((state) => state.users.user.usrId);

  const handleDelete = async () => {
    const data = { frName: frName };
    const resultAction = await dispatch(removeFavReport({ orgId, usrId, data }));
    toast.success(t('Favourite report removed successfully.'));
    unwrapResult(resultAction);
    history.push(`/reports`);
  };

  return (
    <Button
      variant="secondary"
      className="d-flex align-items-center justify-content-center"
      onClick={handleDelete}
    >
      <div className="mr-3"></div>
      <div>{t('Delete')}</div>
    </Button>
  );
};
export default DeleteButton;
